import { Suspense } from 'react';

import { Outlet } from 'react-router-dom';

import { Footer } from '../template/Footer';
import { Navbar } from '../template/navbar/Navbar';
import PageLoader from '../template/PageLoader';

const UserLayout = () => {
  return (
    <div className="bg-radial-dots bg-[length:32px_32px] flex flex-col relative flex-auto min-h-screen min-w-0 w-full">
      <Navbar />
      <div className="h-full flex flex-auto flex-col justify-between mt-16">
        <Suspense fallback={<PageLoader />}>
          <main className="relative h-full flex flex-auto flex-col p-2 sm:px-6 md:px-8 sm:py-6 container">
            <Outlet />
          </main>
        </Suspense>
        <Footer />
      </div>
    </div>
  );
};

export default UserLayout;
